export default {
  fr: {
    time: {
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  en: {
    time: {
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}
